import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import classNames from 'classnames';

import NavBar from 'components/NavBar';
import RECORDINGS_SIDEBAR_DATA from 'data/recordingsSidebarData';
import styles from './RecordingsSidebar.module.scss';
import WithPermissions from 'components/WithPermissions';
import ElementSpacePlaceholder from 'components/ElementSpacePlaceholder';

export default function RecordingsSidebar() {
  return (
    <>
      <NavBar
        title="RECORDING REQUEST TOOL"
        className="p-xs"
        id="recordings-sidebar"
      />
      <ElementSpacePlaceholder elementId="recordings-sidebar" />
      <div className={styles.root}>
        {RECORDINGS_SIDEBAR_DATA.map((data, sectionIndex) => (
          <div
            className={styles.section}
            key={sectionIndex}
          >
            <div
              className={classNames('bold dark', styles.header)}
              key={sectionIndex}
            >
              {data.header}
            </div>
            <div className={styles.tabs}>
              {data.tabs.map((tab, tabIndex) => (
                <WithPermissions
                  key={tabIndex}
                  subject={tab.subject}
                  permissions={tab.permissions}
                >
                  <NavLink
                    to={tab.to}
                    tabIndex={tabIndex}
                    className={({ isActive }) =>
                      classNames(styles.tab, { [styles.tabActive]: isActive })
                    }
                  >
                    {tab.tabName}
                  </NavLink>
                </WithPermissions>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className={styles.page}>
        <Outlet />
      </div>
    </>
  );
}
